import { providers } from 'ethers';

// TODO: Duplicate of ChainId
export enum Chains {
  Ethereum = 1,
  Goerli = 5,
  Polygon = 137,
  Mumbai = 80001,
}

export const RPC_URLS: { [key: number]: string } = {
  [Chains.Ethereum]:
    'https://eth-mainnet.g.alchemy.com/v2/R-A5nWd5LnZR3-bR9s5n7sU-eYCBKKhO',
  [Chains.Goerli]:
    'https://eth-goerli.g.alchemy.com/v2/LVuLnd0Gzb7qLMNfNMgbDxg1H6gnHP7p',
};

export const getJsonRpcProvider = (chainId: number) => {
  const rpcUrl = RPC_URLS[chainId];
  if (!rpcUrl) {
    throw new Error(`Cannot resolve rpcUrl for chainId: ${chainId}`);
  }
  return new providers.JsonRpcProvider(rpcUrl);
};
